import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useField } from '@unform/core';

import { Container } from './styles';

const Input = ({ name, label, className, readOnly, ...rest }) => {
  const inputRef = useRef(null);
  const {
    fieldName,
    registerField,
    defaultValue,
    error,
    clearError,
  } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <Container className={className} readOnly={readOnly} error={error ? 1 : 0}>
      <label>{label}</label>
      <input
        ref={inputRef}
        defaultValue={defaultValue}
        readOnly={readOnly}
        onFocus={clearError}
        {...rest}
      />
      {error && <span>{error}</span>}
    </Container>
  );
};

export default Input;

Input.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  className: PropTypes.string,
  readOnly: PropTypes.bool,
};

Input.defaultProps = {
  label: null,
  className: null,
  readOnly: false,
};
